import { Card } from "shared/components/Card";

export const SkeletonCard = ({ count = 4 }: { count?: number }) => {
  return (
    <div className="space-y-3">
      {Array(count)
        .fill(1)
        .map((_, index) => (
          <Card
            className="animate-appear bg-white p-3"
            key={index + "_skeleton"}
          >
            <div role="status" className="space-y-2.5 animate-pulse max-w-lg">
              <div className="flex items-center w-full">
                <div className="h-2.5 bg-alpha-40 rounded-full w-32"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-24"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
              </div>
              <div className="flex items-center w-full max-w-[480px]">
                <div className="h-2.5 bg-alpha-40 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-24"></div>
              </div>
              <div className="flex items-center w-full max-w-[400px]">
                <div className="h-2.5 bg-alpha-100 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-40 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
              </div>
              <div className="flex items-center w-full max-w-[480px]">
                <div className="h-2.5 ms-2 bg-alpha-40 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-24"></div>
              </div>
              <div className="flex items-center w-full max-w-[440px]">
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-32"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-24"></div>
                <div className="h-2.5 ms-2 bg-alpha-40 rounded-full w-full"></div>
              </div>
              <div className="flex items-center w-full max-w-[360px]">
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-40 rounded-full w-full"></div>
                <div className="h-2.5 ms-2 bg-alpha-100 rounded-full w-full"></div>
              </div>
              <span className="sr-only">Loading...</span>
            </div>
          </Card>
        ))}
    </div>
  );
};
